import TableHead from '@mui/material/TableHead';
import { TableCellBody, TableCellHead, TableRow } from '../common/Table';
import TableBody from '@mui/material/TableBody';
import Table from '@mui/material/Table';
import { decode } from 'he';
import { ReactComponent as PencilIcon } from '../../icons/pencil.svg';
import { Grid, IconButton, SvgIcon } from '@mui/material';
import { PlaylistAPIData } from '../types/playlist';
import { ReactComponent as CopyContentIcon } from '../../icons/copy-content.svg';
import copyToClipboard from '../utils/copyToClipboard';
import { useNavigate } from 'react-router-dom';
import PlaylistRefreshedDate from '../PlaylistRefreshedDate';
import CopyrightIcon from '@mui/icons-material/Copyright';
import CancelIcon from '@mui/icons-material/Cancel';
import VideoLibraryIcon from '@mui/icons-material/VideoLibrary';
import Link from '@mui/material/Link';

export const PlaylistTable = ({
  playlists,
  onEditPlaylist,
  onRemovePlaylist,
}: {
  playlists: PlaylistAPIData[],
  onEditPlaylist: (data: PlaylistAPIData) => void
  onRemovePlaylist: (data: PlaylistAPIData) => void
}) => {
  const navigate = useNavigate();
  return (
    <Table size="small">
      <TableHead>
        <TableRow>
          <TableCellHead>TOTAL PLAYS</TableCellHead>
          <TableCellHead>THUMBNAIL</TableCellHead>
          <TableCellHead>NAME</TableCellHead>
          <TableCellHead>TOTAL VIDEOS</TableCellHead>
          <TableCellHead>FORMAT</TableCellHead>
          <TableCellHead>TYPE</TableCellHead>
          <TableCellHead>ENABLED</TableCellHead>
          <TableCellHead>LAST REFRESHED</TableCellHead>
          <TableCellHead sx={{ minWidth: '100px' }}>TOOLS</TableCellHead>
        </TableRow>
      </TableHead>
      <TableBody>
        {playlists &&
          playlists.map(row => (
            <TableRow
              sx={{
                height: '60px',
              }}
              key={row.uuid}
            >
              <TableCellBody>{row.play_count.toLocaleString()}</TableCellBody>
              <TableCellBody>
                <img
                  src={row.first_video_thumbnail + '?width=135'}
                  alt=""
                  style={{
                    maxWidth: '70px',
                    maxHeight: '100px',
                    width: 'auto',
                    height: 'auto',
                    objectFit: 'contain'
                  }}
                />
              </TableCellBody>
              <TableCellBody sx={{ minWidth: '287px' }}><Link style={{ cursor: 'pointer'}} onClick={() => navigate(`/playlist/${row.uuid as string}`)}>{decode(row.name)}</Link>
                <div title={row.uuid as string} style={{ cursor: 'pointer', marginTop: '10px' }}>
                  <SvgIcon
                    onClick={copyToClipboard(row.uuid as string)}><CopyContentIcon/></SvgIcon>
                </div>
              </TableCellBody>
              <TableCellBody>{row.video_count}</TableCellBody>

              <TableCellBody>{row.format}</TableCellBody>
              <TableCellBody>{row.playlist_type_name}</TableCellBody>
              <TableCellBody>{row.is_active ? 'YES' : 'NO'}</TableCellBody>
              <TableCellBody><PlaylistRefreshedDate lastRefreshed={row.last_refreshed}
                                                    refreshRateInMins={row.refresh_rate_in_mins as number}/></TableCellBody>
              <TableCellBody>
                <Grid container flexWrap={'nowrap'} alignItems={'center'}  spacing={2}>
                  <Grid item>
                    <IconButton

                      color={'primary'}
                      onClick={() => navigate(`/playlist/${row.uuid as string}`)}
                    >
                      <VideoLibraryIcon/>
                    </IconButton>
                  </Grid>
                  <Grid item>
                    <IconButton
                      color={'primary'}
                      onClick={() => navigate(`/playlist/creative/${row.uuid as string}`)}
                    ><CopyrightIcon/></IconButton>
                  </Grid>
                  <Grid item>
                    <IconButton
                      color={'primary'}
                      onClick={() => onEditPlaylist(row)}
                    ><PencilIcon /></IconButton>
                  </Grid>
                  <Grid item>
                    <IconButton
                      color={'primary'}
                      onClick={() => onRemovePlaylist(row)}
                    >
                      <CancelIcon sx={{ fill: '#F75F2A' }} />
                    </IconButton>
                  </Grid>
                </Grid>
              </TableCellBody>
            </TableRow>
          ))}
      </TableBody>
    </Table>
  );
};
